<div class="page__section -small-bottom-padding">
  <h3>Files</h3>
  <ul>
    <li *ngFor="let file of files">
      <a *ngIf="file.file_url" [href]="file.file_url" [innerHTML]="file.title || 'Untitled File'" target="_blank"></a>
    </li>
  </ul>
</div>